import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { StickyCTA } from './components/StickyCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
// Lazy load below-the-fold sections
const PromiseSection = lazy(() => import('./components/PromiseSection').then(m => ({
  default: m.PromiseSection
})));
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const SocialProofSection = lazy(() => import('./components/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const QualificationSection = lazy(() => import('./components/QualificationSection').then(m => ({
  default: m.QualificationSection
})));
const CheckoutSection = lazy(() => import('./components/CheckoutSection').then(m => ({
  default: m.CheckoutSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-green selection:text-white pb-20 md:pb-0" data-id="element-0">
      {/* Critical above-the-fold */}
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />

      {/* Lazy loaded sections */}
      <Suspense fallback={null} data-id="element-3">
        <PromiseSection data-id="element-4" />
        <ProductSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <SocialProofSection data-id="element-7" />
        <QualificationSection data-id="element-8" />
        <CheckoutSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </Suspense>

      <StickyCTA data-id="element-12" />
      <SocialProofPopup data-id="element-13" />
    </div>;
}